<template>
  <main>
    <PageIntro
      :heading="'Your <span>' +configStrings.productName + '</span>'"
      :body="'<p>Please enter your email and we\'ll send you a code and instructions to reset your password.</p>'" />
    <ForgotPasswordForm />
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import ForgotPasswordForm from '@/components/ForgotPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ForgotPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>
